export interface InAppChatService {
  initialize: () => void;
  open: () => void;
  /**
   * @deprecated Use InAppSalesChatService.show or window.(top.)services.inAppSalesChat.show instead
   */
  show: () => void;
  /**
   * @deprecated Use InAppSalesChatService.hide or window.(top.)services.inAppSalesChat.hide instead
   */
  hide: () => void;
}

export enum SupportChatStatus {
  Online = 'online',
  Away = 'away',
  Offline = 'offline',
}
